export default __webpack_public_path__ + "2a5604737d2f8d122156fe1897bce5ea.png";